<template>
  <div class="app-container userDeptTree">
    <el-row :gutter="20">
      <!--部门数据-->
      <el-col :span="4" :xs="24">
        <div class="head-container">
          <el-input
            v-model="deptName"
            placeholder="请输入部门名称"
            clearable
            size=""
            prefix-icon="el-icon-search"
            style="margin-bottom: 20px"
          />
        </div>
        <div class="head-container">
          <el-tree
            :data="deptOptions"
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            ref="tree"
            default-expand-all
            @node-click="handleNodeClick"
          />
        </div>
      </el-col>
      <!--用户数据-->
      <el-col :span="20" :xs="24">
        <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px">
          <el-form-item label="用户昵称" prop="nickName">
            <el-input
              v-model="queryParams.nickName"
              placeholder="请输入用户昵称"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="工号" prop="employeeNo">
            <el-input v-model="queryParams.employeeNo" placeholder="请输入工号" clearable maxlength="100" style="width: 240px" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="手机号码" prop="phonenumber">
            <el-input
              v-model="queryParams.phonenumber"
              placeholder="请输入手机号码"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="状态" prop="tenantUserStatus">
            <el-select
              v-model="queryParams.tenantUserStatus"
              placeholder="用户状态"
              clearable
              style="width: 240px"
            >
              <el-option
                v-for="dict in statusOptions"
                :key="dict.dictValue"
                :label="dict.dictLabel"
                :value="dict.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="角色" prop="roleIdList">
            <el-select v-model="queryParams.roleIdList" placeholder="请选择" clearable filterable multiple style="width: 240px">
              <el-option v-for="dict in roleQueryOptions" :key="dict.roleId" :label="dict.roleName" :value="dict.roleId"/>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="dateRange"
              size=""
              style="width: 240px"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="handleAdd"
              v-hasPermi="['system:user:add']"
            >新增</el-button>
          </el-col>
<!--          <el-col :span="1.5">-->
<!--            <el-button-->
<!--              type="success"-->
<!--              icon="el-icon-edit"-->
<!--              size=""-->
<!--              :disabled="single"-->
<!--              @click="handleUpdate"-->
<!--              v-hasPermi="['system:user:edit']"-->
<!--            >修改</el-button>-->
<!--          </el-col>-->
          <el-col :span="1.5">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size=""
              :disabled="multiple"
              @click="handleDelete"
              v-hasPermi="['system:user:remove']"
            >删除</el-button>
          </el-col>
<!--          <el-col :span="1.5">-->
<!--            <el-button-->
<!--              type="info"-->
<!--              icon="el-icon-upload2"-->
<!--              size=""-->
<!--              @click="handleImport"-->
<!--              v-hasPermi="['system:user:import']"-->
<!--            >导入</el-button>-->
<!--          </el-col>-->
          <el-col :span="1.5">
            <el-button
              type="warning"
              icon="el-icon-download"
              size=""
              @click="handleExport"
              v-hasPermi="['system:user:export']"
            >导出</el-button>
          </el-col>
          <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
        </el-row>

        <el-table v-loading="loading" :data="userList" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" align="center" :selectable="rowSelectable"/>
          <el-table-column label="用户编号" width="80" align="center" prop="userId" />
          <el-table-column label="用户昵称" min-width="80"  align="center" prop="nickName" :show-overflow-tooltip="true" />
          <el-table-column label="工号" prop="employeeNo" width="130" align="center" :show-overflow-tooltip="true" />
          <el-table-column label="部门" align="center" prop="dept.deptName" :show-overflow-tooltip="true" />
          <el-table-column label="手机号码" align="center" prop="phonenumber" width="120" />
          <el-table-column label="角色" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-for="(role, index) in scope.row.roles" :key="index">{{index === 0 ? '' : '、'}}{{role.roleName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" prop="tenantUserStatusDesc" width="120" />
          <el-table-column label="创建时间" align="center" prop="createTime" width="170">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="250"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-button
                :disabled="scope.row.admin && !currentUser.admin"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
                v-hasPermi="['system:user:edit']"
              >修改</el-button>
              <el-button
                :disabled="scope.row.admin && !currentUser.admin"
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                v-hasPermi="['system:user:remove']"
              >删除</el-button>
              <el-button
                type="text"
                icon="el-icon-key"
                @click="handleResetPwd(scope.row)"
                v-hasPermi="['system:user:resetPwd']"
              >重置</el-button>
              <el-button
                type="text"
                v-show="scope.row.tenantUserStatus == 1"
                icon="el-icon-folder-remove"
                @click="setStatus(scope.row)"
              >设为离职</el-button>
              <el-button
                type="text"
                v-show="scope.row.tenantUserStatus == 2"
                icon="el-icon-folder-add"
                @click="setStatus(scope.row)"
              >恢复职位</el-button>
              <!-- v-hasPermi="['system:user:demission']" -->
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </el-col>
    </el-row>

    <!-- 添加或修改参数配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phonenumber">
              <el-input :disabled="Boolean(form.userId)" v-model="form.phonenumber" placeholder="请输入手机号码" maxlength="11" @input="phoneChange"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户密码" :prop="Boolean(form.userId) || addUserExist ? '' : 'password'">
              <el-input v-if="Boolean(form.userId) || addUserExist" :disabled="true" value="******" placeholder=""/>
              <el-input v-else v-model="form.password" placeholder=""/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户昵称" prop="nickName">
              <el-input v-model="form.nickName" placeholder="请输入用户昵称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户性别">
              <el-select v-model="form.sex" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="dict in sexOptions"
                  :key="dict.dictValue"
                  :label="dict.dictLabel"
                  :value="dict.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="deptId">
              <treeselect v-model="form.deptId" :options="deptOptions" :show-count="true" placeholder="请选择归属部门" style="width: 100%;"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="岗位">
              <el-select v-model="form.postIds" multiple placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in postOptions"
                  :key="item.postId"
                  :label="item.postName"
                  :value="item.postId"
                  :disabled="item.status == 1"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="角色" prop="roleIds">
              <el-select v-model="form.roleIds" multiple placeholder="请选择" :disabled="form.admin" style="width: 100%;">
                <el-option
                  v-for="item in roleOptions"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId"
                  :disabled="item.status == 1"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="钉钉User ID" prop="dingtalkUserId">
              <el-input v-model="form.dingtalkUserId" placeholder="请输入钉钉User ID" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12"><el-form-item label="工号" prop="employeeNo"><el-input v-model="form.employeeNo" placeholder="请输入工号，可留空" maxlength="100" clearable /><small style="color:#909399">支持手工填写和修改，工号在本企业内唯一。</small></el-form-item></el-col>
        </el-row>
<!--        <el-row>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="状态">-->
<!--              <el-radio-group v-model="form.status" :disabled="form.admin">-->
<!--                <el-radio-->
<!--                  v-for="dict in statusOptions"-->
<!--                  :key="dict.dictValue"-->
<!--                  :label="dict.dictValue"-->
<!--                >{{dict.dictLabel}}</el-radio>-->
<!--              </el-radio-group>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="24">-->
<!--            <el-form-item label="备注">-->
<!--              <el-input v-model="form.remark" type="textarea" placeholder="请输入内容"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 员工离职审批交接对话框 -->
    <el-dialog
      title="离职审批交接"
      :visible.sync="handoverOpen"
      width="880px"
      custom-class="handover-dialog"
      append-to-body
      :close-on-click-modal="false"
      @closed="resetHandover"
    >
      <el-alert
        :title="handoverAlertTitle"
        :type="handoverPreviewLoaded && handoverPreviewList.length === 0 ? 'info' : 'warning'"
        :closable="false"
        show-icon
      />
      <el-form
        ref="handoverForm"
        :model="handoverForm"
        :rules="handoverRules"
        label-width="88px"
        class="handover-form"
      >
        <el-form-item label="离职员工">
          <el-input :value="handoverForm.sourceUserName" disabled />
        </el-form-item>

        <div class="handover-preview-section">
          <div class="handover-preview-header">
            <div>
              <span class="handover-preview-title">待交接审批单</span>
              <span class="handover-preview-tip">以下清单按确认时的最新审批状态执行</span>
            </div>
            <el-tag v-if="handoverPreviewLoaded" size="small" type="warning">
              {{ handoverPreviewList.length }}张单 / {{ handoverTaskCount }}个节点
            </el-tag>
          </div>
          <el-table
            v-loading="handoverPreviewLoading"
            :data="handoverPreviewList"
            border
            size="mini"
            max-height="280"
            :empty-text="handoverPreviewLoaded ? '当前没有需要交接的审批单，确认后将设置为离职' : '待交接清单加载失败，请关闭后重试'"
          >
            <el-table-column label="审批类型" prop="approvalTypeDesc" width="112" />
            <el-table-column label="业务单据" min-width="235">
              <template slot-scope="{ row }">
                <div class="handover-business-cell">
                  <span class="handover-business-no">{{ row.businessNo || `SP${row.workOrderId}` }}</span>
                  <span class="handover-business-name">{{ row.businessName || row.approvalTypeDesc }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="当前节点" min-width="155">
              <template slot-scope="{ row }">
                <span>{{ (row.currentTaskNames || []).join('、') || '当前审批节点' }}</span>
                <el-tag v-if="row.taskCount > 1" size="mini" type="info" class="handover-node-count">
                  {{ row.taskCount }}个
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="发起人" prop="applicantName" width="92" />
            <el-table-column label="发起时间" prop="createTime" width="145" />
          </el-table>
        </div>

        <div class="handover-preview-section asset-handover-section">
          <div class="handover-preview-header">
            <div>
              <span class="handover-preview-title">员工名下资产</span>
              <span class="handover-preview-tip">存在未归还资产或尚未完成的资产流转时，系统禁止设置离职</span>
            </div>
            <el-tag v-if="handoverAssetLoaded" size="small" :type="handoverAssetList.length ? 'danger' : 'success'">
              {{ handoverAssetList.length }}项待处理
            </el-tag>
          </div>
          <el-table
            v-loading="handoverAssetLoading"
            :data="handoverAssetList"
            border
            size="mini"
            max-height="220"
            :empty-text="handoverAssetLoaded ? '该员工名下无待处理资产' : '资产清单加载失败，请关闭后重试'"
          >
            <el-table-column label="资产编号" prop="assetCode" width="145" />
            <el-table-column label="资产名称" prop="assetName" min-width="180" />
            <el-table-column label="分类" prop="categoryNameSnapshot" width="120" />
            <el-table-column label="存放位置" prop="storageLocation" min-width="150" />
            <el-table-column label="当前状态" width="110">
              <template slot-scope="{ row }">
                <span>{{ assetStatusText(row.status) }}</span>
                <el-tag v-if="row.pendingOperationId" type="warning" size="mini">流转中</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-form-item label="交接给" prop="targetUserId">
          <el-select
            v-model="handoverForm.targetUserId"
            filterable
            clearable
            style="width: 100%;"
            placeholder="搜索并选择在职员工"
            :loading="handoverUserLoading"
          >
            <el-option
              v-for="user in handoverUserOptions"
              :key="user.userId"
              :label="handoverUserLabel(user)"
              :value="user.userId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="交接说明" prop="remark">
          <el-input
            v-model="handoverForm.remark"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="选填，如：员工离职审批事项统一交接"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handoverOpen = false">取消</el-button>
        <el-button
          type="primary"
          :loading="handoverSubmitting"
          :disabled="handoverPreviewLoading || !handoverPreviewLoaded || handoverAssetLoading || !handoverAssetLoaded || handoverAssetList.length > 0"
          @click="confirmHandover"
        >
          确认交接并离职
        </el-button>
      </span>
    </el-dialog>

    <!-- 用户导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
      <el-upload
        ref="upload"
        :limit="1"
        accept=".xlsx, .xls"
        :headers="upload.headers"
        :action="upload.url + '?updateSupport=' + upload.updateSupport"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :on-success="handleFileSuccess"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          <el-checkbox v-model="upload.updateSupport" />是否更新已经存在的用户数据
          <el-link type="info" style="font-size:12px" @click="importTemplate">下载模板</el-link>
        </div>
        <div class="el-upload__tip" style="color:red" slot="tip">提示：仅允许导入“xls”或“xlsx”格式文件！</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upload.open = false">取消</el-button>
        <el-button type="primary" @click="submitFileForm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  addUser,
  changeUserStatus,
  checkPhoneOnAdd,
  delUser,
  exportUser,
  getUser,
  getHandoverPreview,
  handoverAndLeave,
  importTemplate,
  listUser,
  listUserWithOutDataScope,
  resetUserPwd,
  updateUser
} from "@/api/system/user";
import {getToken} from "@/utils/auth";
import {treeselect} from "@/api/system/dept";
import {roleOptionSelect} from "@/api/system/role";
import Treeselect from "@riophae/vue-treeselect";
import {isPhone} from "@/utils/validate";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {mapState} from "vuex";
import {getOutstandingAssets} from "@/api/crm/asset";

export default {
  name: "User",
  components: { Treeselect },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户表格数据
      userList: null,
      // 弹出层标题
      title: "",
      // 部门树选项
      deptOptions: undefined,
      // 是否显示弹出层
      open: false,
      // 是否显示离职审批交接弹窗
      handoverOpen: false,
      handoverSubmitting: false,
      handoverUserLoading: false,
      handoverUserOptions: [],
      handoverPreviewLoading: false,
      handoverPreviewLoaded: false,
      handoverPreviewList: [],
      handoverAssetLoading: false,
      handoverAssetLoaded: false,
      handoverAssetList: [],
      handoverForm: {
        sourceUserId: undefined,
        sourceUserName: "",
        targetUserId: undefined,
        remark: ""
      },
      handoverRules: {
        targetUserId: [
          { required: true, message: "请选择审批交接人", trigger: "change" }
        ],
        remark: [
          { max: 500, message: "交接说明不能超过500个字符", trigger: "blur" }
        ]
      },
      // 部门名称
      deptName: undefined,
      // // 默认密码
      // initPassword: undefined,
      // 日期范围
      dateRange: [],
      // 状态数据字典
      statusOptions: [
        {dictLabel: '正常', dictValue: 1},
        {dictLabel: '离职', dictValue: 2}
      ],
      // 性别状态字典
      sexOptions: [],
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      roleQueryOptions: [],
      // 表单参数
      form: {},
      addUserExist: false,
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: "Bearer " + getToken(), "Terminal-Type": "PC", platform: "pc" },
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + "/system/user/importData"
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        roleIdList: [],
        phonenumber: undefined,
        employeeNo: undefined,
        tenantUserStatus: 1,
        deptId: undefined
      },
      // 表单校验
      rules: {
        employeeNo: [{ max: 100, message: '工号不能超过100个字符', trigger: 'blur' }],
        nickName: [
          { required: true, message: "用户昵称不能为空", trigger: "blur" }
        ],
        deptId: [
          { required: true, message: "归属部门不能为空", trigger: "change" }
        ],
        password: [
          { required: true, message: "用户密码不能为空", trigger: "blur" }
        ],
        phonenumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        roleIds: [
          { required: true, message: "角色不能为空", trigger: "change" }
        ]
      }
    };
  },
  watch: {
    // 根据名称筛选部门树
    deptName(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.getRoleQueryOptions()
    this.getList();
    this.getTreeselect();
    this.getDicts("sys_user_sex").then(response => {
      this.sexOptions = response.data;
    });
    // this.getConfigKey("sys.user.initPassword").then(response => {
    //   this.initPassword = response.msg;
    // });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
      currentUser: state => state.user
    }),
    handoverTaskCount() {
      return this.handoverPreviewList.reduce(
        (total, item) => total + (Number(item.taskCount) || 0),
        0
      )
    },
    handoverAlertTitle() {
      if (this.handoverPreviewLoading || this.handoverAssetLoading) {
        return "正在核对该员工当前需要交接的审批单和名下资产，请稍候。"
      }
      if (!this.handoverPreviewLoaded || !this.handoverAssetLoaded) {
        return "离职交接清单加载失败，请关闭弹窗后重试，清单未确认前不能设置离职。"
      }
      if (this.handoverAssetList.length > 0) {
        return `该员工还有${this.handoverAssetList.length}项资产尚未归还或交接尚未完成，请联系资产保管人或管理员处理；完成后再办理离职。`
      }
      if (this.handoverPreviewList.length === 0) {
        return "该员工当前没有待交接审批单，确认后将直接设置为离职。"
      }
      return `请核对下方${this.handoverPreviewList.length}张审批单、${this.handoverTaskCount}个审批节点；全部交接成功后员工才会被设置为离职。`
    }
  },
  methods: {
    /** 查询用户列表 */
    getList() {
      this.loading = true;
      let param = JSON.parse(JSON.stringify(this.queryParams))
      if (param.roleIdList) {
        param.roleIdList = param.roleIdList.join(',')
      }
      listUser(this.addDateRange(param, this.dateRange)).then(response => {
          this.userList = response.rows;
          this.total = response.total;
          this.loading = false;
        }
      );
    },
    /** 查询部门下拉树结构 */
    getTreeselect() {
      treeselect().then(response => {
        this.deptOptions = response.data;
      });
    },
    getRoleQueryOptions() {
      roleOptionSelect().then(response => {
        this.roleQueryOptions = response.data;
      });
    },
    // 筛选节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 节点单击事件
    handleNodeClick(data) {
      this.queryParams.deptId = data.id;
      this.getList();
    },
    rowSelectable(row, index) {
      return !row.admin;
    },
    phoneChange(phonenumber) {
      // 新增用户的时候需要校验
      if (!this.form.userId && isPhone(phonenumber)) {
        checkPhoneOnAdd(phonenumber).then(response => {
            if (response.data && response.data.userId) {
              this.addUserExist = true;
              this.form.nickName = response.data.nickName;
              this.form.sex = response.data.sex;
              // this.form.password = this.initPassword;
            } else {
              // 如果上一次校验手机号是已存在的，这一次不存在，则要清空下信息
              if (this.addUserExist) {
                this.form.password = undefined;
                this.form.nickName = undefined;
                this.form.sex = undefined;
              }
              this.addUserExist = false;
            }
          }
        ).catch(error => {
          this.addUserExist = false;
        })
      }
    },
    /**
     * @author lee
     * @description
     * @date 2021-05-27
    */
    setStatus (row) {
      if (row.tenantUserStatus == 1) {
        this.openHandoverDialog(row)
        return
      }
      this.$confirm('是否恢复当前人员为在职状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        changeUserStatus(row.userId, 1).then(response => {
          this.msgSuccess("状态更新成功");
          this.getList()
          this.loading = false;
        }).catch(data => {
          this.loading = false;
        })
      })
    },
    openHandoverDialog(row) {
      this.handoverForm = {
        sourceUserId: row.userId,
        sourceUserName: row.nickName || row.userName || `用户${row.userId}`,
        targetUserId: undefined,
        remark: ""
      }
      this.handoverOpen = true
      this.loadHandoverUsers(row.userId)
      this.loadHandoverPreview(row.userId)
      this.loadHandoverAssets(row.userId)
    },
    loadHandoverPreview(sourceUserId) {
      this.handoverPreviewLoading = true
      this.handoverPreviewLoaded = false
      this.handoverPreviewList = []
      getHandoverPreview(sourceUserId).then(response => {
        if (Number(this.handoverForm.sourceUserId) !== Number(sourceUserId)) {
          return
        }
        this.handoverPreviewList = (response && response.data) || []
        this.handoverPreviewLoaded = true
      }).finally(() => {
        if (Number(this.handoverForm.sourceUserId) === Number(sourceUserId)) {
          this.handoverPreviewLoading = false
        }
      })
    },
    loadHandoverUsers(sourceUserId) {
      this.handoverUserLoading = true
      listUserWithOutDataScope({ pageNum: 1, pageSize: 999, tenantUserStatus: 1 }).then(response => {
        const rows = (response && response.rows) || []
        this.handoverUserOptions = rows.filter(user =>
          Number(user.userId) !== Number(sourceUserId)
          && String(user.status || '0') === '0'
          && Number(user.tenantUserStatus || 1) === 1
        )
      }).finally(() => {
        this.handoverUserLoading = false
      })
    },
    loadHandoverAssets(sourceUserId) {
      this.handoverAssetLoading = true
      this.handoverAssetLoaded = false
      this.handoverAssetList = []
      getOutstandingAssets(sourceUserId).then(response => {
        if (Number(this.handoverForm.sourceUserId) !== Number(sourceUserId)) {
          return
        }
        this.handoverAssetList = (response && response.data) || []
        this.handoverAssetLoaded = true
      }).finally(() => {
        if (Number(this.handoverForm.sourceUserId) === Number(sourceUserId)) {
          this.handoverAssetLoading = false
        }
      })
    },
    assetStatusText(status) {
      return ({ 10: '闲置', 20: '在用', 30: '维修', 40: '丢失', 50: '待报废', 60: '已报废' })[Number(status)] || '-'
    },
    handoverUserLabel(user) {
      const name = user.nickName || user.userName || `用户${user.userId}`
      const deptName = user.dept && user.dept.deptName
      return deptName ? `${name}（${deptName}）` : name
    },
    confirmHandover() {
      if (!this.handoverPreviewLoaded) {
        this.msgError("待交接审批单尚未加载完成，请稍后重试")
        return
      }
      if (!this.handoverAssetLoaded) {
        this.msgError("员工资产清单尚未加载完成，请稍后重试")
        return
      }
      if (this.handoverAssetList.length > 0) {
        this.msgError("该员工仍有资产待处理，不能设置离职")
        return
      }
      this.$refs.handoverForm.validate(valid => {
        if (!valid) {
          return
        }
        this.handoverSubmitting = true
        handoverAndLeave({
          sourceUserId: this.handoverForm.sourceUserId,
          targetUserId: this.handoverForm.targetUserId,
          remark: this.handoverForm.remark
        }).then(response => {
          const handoverCount = Number(response && response.data) || 0
          this.handoverOpen = false
          this.msgSuccess(handoverCount > 0
            ? `已完成离职并交接${handoverCount}个审批节点`
            : "已设置离职，当前没有需要交接的审批节点")
          this.getList()
        }).finally(() => {
          this.handoverSubmitting = false
        })
      })
    },
    resetHandover() {
      this.handoverForm = {
        sourceUserId: undefined,
        sourceUserName: "",
        targetUserId: undefined,
        remark: ""
      }
      this.handoverUserOptions = []
      this.handoverPreviewList = []
      this.handoverPreviewLoaded = false
      this.handoverPreviewLoading = false
      this.handoverAssetList = []
      this.handoverAssetLoaded = false
      this.handoverAssetLoading = false
      if (this.$refs.handoverForm) {
        this.$refs.handoverForm.clearValidate()
      }
    },
    // 用户状态修改
    // handleStatusChange(row) {
    //   let text = row.status === "0" ? "启用" : "停用";
    //   this.$confirm('确认要"' + text + '""' + row.phonenumber + '"用户吗?', "警告", {
    //       confirmButtonText: "确认",
    //       cancelButtonText: "取消",
    //       type: "warning"
    //     }).then(function() {
    //       return changeUserStatus(row.userId, row.status);
    //     }).then(() => {
    //       this.msgSuccess(text + "成功");
    //     }).catch(function() {
    //       row.status = row.status === "0" ? "1" : "0";
    //     });
    // },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        userId: undefined,
        deptId: undefined,
        nickName: undefined,
        password: undefined,
        phonenumber: undefined,
        sex: undefined,
        status: "0",
        remark: undefined,
        postIds: [],
        roleIds: [],
        dingtalkUserId: undefined,
        employeeNo: undefined
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.queryParams.tenantUserStatus = 1;
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.userId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.getTreeselect();
      getUser().then(response => {
        this.postOptions = response.posts;
        this.roleOptions = response.roles;
        this.open = true;
        this.addUserExist = false;
        this.title = "添加用户";
        this.form.password = undefined;
      });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.getTreeselect();
      const userId = row.userId || this.ids;
      getUser(userId).then(response => {
        this.form.userId = response.data.userId;
        this.form.deptId = response.data.deptId;
        this.form.nickName = response.data.nickName;
        this.form.phonenumber = response.data.phonenumber;
        this.form.sex = response.data.sex;
        this.form.status = response.data.status;
        this.form.remark = response.data.remark;
        this.form.postIds = response.postIds;
        this.form.roleIds = response.roleIds;
        this.form.dingtalkUserId = response.data.dingtalkUserId;
        this.form.employeeNo = response.data.employeeNo || '';

        this.postOptions = response.posts;
        this.roleOptions = response.roles;
        this.open = true;
        this.addUserExist = false;
        this.title = "修改用户";
        this.form.password = "";
      });
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$prompt('请输入"' + row.phonenumber + '"的新密码', "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(({ value }) => {
          resetUserPwd(row.userId, value).then(response => {
            this.msgSuccess("修改成功，新密码是：" + value);
          });
        }).catch(() => {});
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
          if (this.form.userId != undefined) {
            updateUser(this.form).then(response => {
              this.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            }).finally(() => {
              loading.close();
            });
          } else {
            addUser(this.form).then(response => {
              this.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            }).finally(() => {
              loading.close();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const userIds = row.userId || this.ids;
      this.$confirm('是否确认删除用户编号为"' + userIds + '"的数据项?', "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          return delUser(userIds);
        }).then(() => {
          this.getList();
          this.msgSuccess("删除成功");
        })
    },
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = this.queryParams;
      this.$confirm('是否确认导出所有用户数据项?', "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          return exportUser(queryParams);
        }).then(response => {
          this.download(response.msg);
        })
    },
    /** 导入按钮操作 */
    handleImport() {
      this.upload.title = "用户导入";
      this.upload.open = true;
    },
    /** 下载模板操作 */
    importTemplate() {
      importTemplate().then(response => {
        this.download(response.msg);
      });
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert(response.msg, "导入结果", { dangerouslyUseHTMLString: true });
      this.getList();
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    }
  }
};
</script>
<style lang='scss' scoped>
.userDeptTree {
  ::v-deep.el-tree-node__label {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
}

.handover-form {
  margin-top: 20px;
}

.handover-preview-section {
  margin: 4px 0 22px;
  padding: 16px;
  background: #f7f9fc;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
}

.handover-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.handover-preview-title {
  color: #303133;
  font-size: 15px;
  font-weight: 600;
}

.handover-preview-tip {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

.handover-business-cell {
  display: flex;
  flex-direction: column;
  line-height: 20px;
}

.handover-business-no {
  color: #303133;
  font-weight: 600;
}

.handover-business-name {
  overflow: hidden;
  color: #606266;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.handover-node-count {
  margin-left: 6px;
}

::v-deep .handover-dialog {
  max-width: calc(100vw - 40px);
}
</style>
